import * as React from "react";
import IncidentList from "./incident-list";

class Index extends React.Component<{}, {}> {
    render = () => {
        return (
            <IncidentList />
        );
    }
}

export default Index;